import "./styles.scss";

// Stateless print table. The interactive tables on the Android report page are
// ReactTableWrapper instances: they paginate at ten rows, put a filter and a
// sort control in every header and inject their own export buttons, so
// html2canvas would only ever capture the first page of each one. This renders
// every row it is given, up to a cap, and nothing else.
//
// Cells hold numbers as often as strings, and a score of 0 is meaningful — so
// only null/undefined/"" fall back to a dash.
export const flatValue = (value) =>
  value === 0 || value === false ? String(value) : value || "-";

// Detail arrays carry either plain strings or nested objects (the interactive
// widgets hand those to JsonView, which is collapsible and therefore useless in
// a print).
export const flatEntry = (entry) =>
  typeof entry === "string" || typeof entry === "number" ? String(entry) : JSON.stringify(entry);

// columns: [{ label, render(row), className? }]
const FlatTable = ({
  columns,
  data,
  maxRows,
  moreLabel = "rows",
  emptyMessage = "No data",
  className = "",
}) => {
  const rows = Array.isArray(data) ? data : [];

  if (rows.length === 0) {
    return <p className="flat-table__empty">{emptyMessage}</p>;
  }

  const visibleRows = maxRows ? rows.slice(0, maxRows) : rows;
  const hiddenCount = rows.length - visibleRows.length;

  return (
    <>
      <table className={`flat-table ${className}`}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.label} className={column.className}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {visibleRows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column) => (
                <td key={column.label} className={column.className}>
                  {column.render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {hiddenCount > 0 ? (
        <p className="flat-table__more">
          +{hiddenCount} more {moreLabel} — see the CSV export for the full list
        </p>
      ) : null}
    </>
  );
};

export default FlatTable;
